import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid'
import './Legend.scss'

function Legend(props) {
    return (
        <Grid container direction='column' className='legend-container'>
            {props.legends.map((legend, index) => (
                <Grid item key={index} className='legend-row-container'>
                    <div style={{ background: legend.color, opacity: legend.opacity }} className='legend-row-color'></div>
                    <div className='legend-row-text' style={{ color: legend.legendTextColor }} >{legend.value}</div>
                </Grid>
            ))}
        </Grid>
    )
}

export default Legend;